import { render, staticRenderFns } from "./EsyParagraph.vue?vue&type=template&id=799f49dc&scoped=true"
import script from "./EsyParagraph.vue?vue&type=script&lang=ts"
export * from "./EsyParagraph.vue?vue&type=script&lang=ts"
import style0 from "./EsyParagraph.vue?vue&type=style&index=0&id=799f49dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f49dc",
  null
  
)

export default component.exports